<template>
    <v-dialog
      v-model="dialog.showDelete"
      max-width="25%"
      persistent
    >
      <v-card>
        <v-card-text class="v-vard-text">
          <v-container>
            <div class="space"></div>
            <div class="success-ring">
              <v-icon class="content-icon">close</v-icon>
            </div>
            <div class="content-msg">{{tips}}</div>
            <v-progress-linear
              v-if="dialog.showProgress"
              class="progress"
              color="#FF5252"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col cols="6">
              <v-btn class="cancel" @click="dialog.showDelete = false">Cancel</v-btn>
            </v-col>
            <v-col cols="6">
          <v-btn class="ensure" @click="deleteItemClick">Delete</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import { FilterApi } from '@/api/pandaria'
export default {
  name: 'SureDeleteDialog',
  props: {
    dialog: Object,
    deleteId: Number,
    tips: String,
    deleteItem: Object,
    operatedBy: Object,
    token: String
  },
  data () {
    return {
    }
  },
  methods: {
    deleteItemClick () {
      const $this = this
      $this.dialog.showProgress = true
      if ($this.tips === 'Are you sure to DELETE the value?') {
        const input = {
          id: $this.deleteId,
          operatedBy: JSON.stringify($this.operatedBy),
          token: $this.token
        }
        FilterApi.deleteRiskFilterValue(input, function () {
          $this.dialog.showProgress = false
          $this.dialog.showDelete = false
          $this.$emit('deleteSuccessful')
        }, function (err) {
          $this.dialog.showProgress = false
          $this.dialog.showDelete = false
          $this.$emit('deletFailure', err.message)
        })
      } else if ($this.tips === 'Are you sure to DELETE ALL values?') {
        const input = {
          id: $this.deleteItem.id,
          operatedBy: JSON.stringify($this.operatedBy),
          token: $this.token
        }
        FilterApi.deleteRiskFilter(input, function () {
          $this.dialog.showProgress = false
          $this.dialog.showDelete = false
          $this.$emit('deleteItemSuccessful')
        }, (err) => {
          $this.dialog.showProgress = false
          $this.dialog.showDelete = false
          $this.$emit('deletFailure', err.message)
        })
      }
    }
  }
}
</script>

<style scoped>
.space {
  width: 140px;
  height: 60px;
  display: inline-block;
}
.success-ring {
  display: inline-block;
  width: 88px;
  height: 88px;
  border: 4px solid #FFC8C8;
  border-radius: 50%;
  text-align: center;
  padding: 20px auto !important;
}
.content-icon {
   color: #FF5252;
   font-size: 60px;
   text-align: center;
   line-height: 80px;
}
.content-msg {
  color: #595959;
  font-size: 16px;
  text-align: center;
  padding-top: 40px;
  padding-bottom: 20px;
}
.content-input {
  -webkit-appearance: none;
  background-color: #fff;
  border: none;
  font-size: 14px;
  display: block;
  box-sizing: border-box;
  width: 100%;
  border: 1px solid rgba(0,0,0,.14);
  padding: 10px 13px;
  border-radius: 2px;
  transition: border-color .2s;
}
.cancel {
  background-color: #EFEFEF !important;
  color: #000;
  font-weight: bolder;
  font-size: 13px;
  padding: 0px 20px !important;
  float: right;
  border-radius: 2px;
  text-transform: none;
}
.ensure {
  background-color: #DC3545 !important;
  color: #fff;
  font-weight: bolder;
  font-size: 13px;
  padding: 0px 20px !important;
  float: left;
  border-radius: 2px;
  text-transform: none;
}
.row {
  margin: -8px;
}
</style>
